import axios from 'axios';
import { ApiResponse } from '../types/api';
import { BlacklistRule, BlacklistRuleCreateRequest } from '../types/blacklistRule';

export interface BlacklistRuleUpdateRequest {
  reason: string;
  note?: string;
  deviceVersion?: string;
}

export const blacklistRuleService = {
  getAll: async (): Promise<BlacklistRule[]> => {
    const res = await axios.get<ApiResponse<BlacklistRule[]>>(
      '/api/admin/blacklist-rules',
      { withCredentials: true }
    );
    return res.data.data;
  },

  create: async (rule: BlacklistRuleCreateRequest): Promise<void> => {
    await axios.post('/api/admin/blacklist-rules', rule, { withCredentials: true });
  },

  update: async (id: number, req: BlacklistRuleUpdateRequest): Promise<void> => {
    await axios.put(`/api/admin/blacklist-rules/${id}`, req, { withCredentials: true });
  },

  delete: async (id: number): Promise<void> => {
    await axios.delete(`/api/admin/blacklist-rules/${id}`, { withCredentials: true });
  },
};
